import useSettings from './useSettings';

/**
 * A hook that provides configuration values for the pages.
 * Returns the total number of sections and the total number of pages
 * required for submission, both for main applicant flow and for co applicant flow.
 * Is country aware and will return different values based on country code.
 *
 * @returns object containing totalSections, totalAboutYouPages, totalAboutTheLoanPages, coApplicantTotalSections and coApplicantTotalAboutYouPages
 */
const usePagesConfig = () => {
    const settings = useSettings();
    const { countryCode } = settings;

    let totalSections,
        totalAboutYouPages,
        totalAboutTheLoanPages,
        coApplicantTotalSections,
        coApplicantTotalAboutYouPages;

    switch (countryCode) {
        case 'NO':
            totalSections = 6;
            // The Norsk Gjeld consent page now always renders (CASH and consolidation),
            // so it is always counted here.
            totalAboutYouPages = settings.withCoApplicant ? 11 : 10;
            totalAboutTheLoanPages = 2;
            coApplicantTotalSections = 4;
            coApplicantTotalAboutYouPages = settings.withCoApplicantConsolidations ? 8 : 6;
            break;
        case 'DK':
            totalSections = 6;
            // Montio (experian credit-check) is temporarily disabled in the wizard (see
            // SubmitApplicationWizardDK.tsx), so it is not counted here.
            totalAboutYouPages = 10;
            totalAboutTheLoanPages = 3;
            coApplicantTotalSections = 3;
            // how-to-apply, eskat-kreditstatus consent, living condition, employment, finance.
            // KYC and submit are the other two sections.
            coApplicantTotalAboutYouPages = 5;
            break;
        default:
            totalSections = 6;
            totalAboutYouPages = 9;
            totalAboutTheLoanPages = 2;
            coApplicantTotalSections = 4;
            coApplicantTotalAboutYouPages = 6;
            break;
    }

    return {
        totalSections,
        totalAboutYouPages,
        totalAboutTheLoanPages,
        coApplicantTotalSections,
        coApplicantTotalAboutYouPages,
    };
};

export default usePagesConfig;
